import SwitchButton from "./SwitchButton";
import PointerEvents from "../../../src/const/PointerEvents";
import BaseView from "../BaseView";
import SceneViewContainer from "../SceneViewContainer";
import { Graphics } from "pixi.js";

export default class SwitchGroup extends BaseView {
  protected buttons: SwitchButton[];
  protected buttonsMask: Graphics;
  protected container: SceneViewContainer;
  protected _onSelect: (value: string) => void = () => {};

  constructor(container: SceneViewContainer) {
    super();
    this.buttons = [];
    this.container = container;
    // this.addChild(container);
  }

  public getBound(): Graphics {
    return this.container.getBoundShape();
  }

  public getChildren(): SwitchButton[] {
    return this.buttons;
  }

  public getContainer(): SceneViewContainer {
    return this.container;
  }

  public setContainer(cont:SceneViewContainer) {
    if(cont!=this.container) {
      return;
    }
    this.container = cont;
  }

  // public addMask(maskDef: IObjectConfig) {
  //     const mask = new Graphics();
  //     mask.beginFill(0xff00ff, .5);
  //     mask.drawRect(0, 0, Layout.scalePixels(maskDef.width), Layout.scalePixels(maskDef.height));
  //     mask.endFill();
  //     mask.x = Layout.scalePixels(maskDef.x - Layout.getX(this));
  //     mask.y = Layout.scalePixels(maskDef.y - Layout.getY(this));
  //     this.addChild(mask);
  //     this.buttonsMask = mask;
  //     this.buttons.forEach(btn => {
  //         btn.mask = this.buttonsMask;
  //     });
  // }

  public onRotate() {
    // this.addChild(this.container);
    this.buttons.forEach((btn) => {
      this.container.addChild(btn);
    });
  }

  public addToGroup(button: SwitchButton) {
    if (this.buttons.indexOf(button) != -1) {
      return;
    }
    this.buttons.push(button);
    this.container.addChild(button);
    this.addButtonListener(button);
    if (this.buttonsMask) {
      button.mask = this.buttonsMask;
    }
  }

  addButtonListener(button: SwitchButton) {
    button.on(
      PointerEvents.DOWN,
      () => {
        const status = button.isSelected();
        this.buttons.forEach((btn) => {
          if (btn !== button) {
            btn.switch(false);
          }
        });
        if (!status) {
          button.switch(true);
          this._onSelect(button.getValue());
        }
      },
      this
    );
  }

  public deselect() {
    this.buttons.forEach((but) => but.switch(false));
  }

  public onSelect(callback) {
    this._onSelect = callback;
  }

  public replaceButtonTexts(modifier: (text: string, index: number) => string) {
    this.buttons.forEach((but, index) => {
      if (but.text) {
        let value = modifier(but.getValue(), index);
        if(value) {
          but.setValue(value);
        } else {
          but.hide()
        }
      }
    });
  }

  public isSelected() {
    return !this.buttons.every((btn) => !btn.isSelected());
  }
}
